// extracted by mini-css-extract-plugin
export default {"container":"GenericModalDocumentation_container__T7XkW","propertyDivider":"GenericModalDocumentation_propertyDivider__FTdej"};